<template>
    <section class="agenda">
        <a id="agenda"></a>
        <h2>Próximos Eventos</h2>
        <section class="preview">
            <div v-for="event in getActiveEvents()" :key="event.id">
                <EventCard :event="event" />
            </div>
        </section>
    </section>
</template>

<script>
import eventsData from '../assets/events.json'
import EventCard from './EventCard.vue';

export default {
    name: 'AgendaPreview',
    components: {
        EventCard
    },
    data() {
        return {
            isSignedIn: false
        }
    },
    methods: {
        getActiveEvents: function () {
          let data = eventsData.data;
          return data.filter(e => this.isEventActive(e));
        },

        isEventInPast: function (event) {
            const today = new Date()
            today.setHours(0, 0, 0, 0)

            const startDate = this.subtractDays(today, 5)
            startDate.setHours(0, 0, 0, 0)

            const eventDate = new Date(event.date)
            eventDate.setHours(0, 0, 0, 0)

            return eventDate > startDate;

        },

        subtractDays: function (date, days) {
            const result = new Date(date);
            result.setDate(result.getDate() - days);
            return result;
        },

        isEventActive: function (event) {
            if (!event)
                return false;

            if (event.active === undefined)
                return this.isEventInPast(event)

            return event.active
        }
    }
}
</script>

<style scoped>
.agenda {
    display: block;
    max-width: 85rem;
    margin: 0 auto;

    h2 {
        display: block;
        font-size: 2rem;
        padding: 1rem 0 0 0;
        font-weight: bold;
        color: #fff;
    }

    .preview {
        /* border: 1px solid white; */
      padding: 0 2rem 2rem;
      display: flex;
        flex-flow: row wrap;
        justify-content: center;

        gap: 2rem;


        h2 {
            color: white;
        }
    }
}
</style>